<template>
  <div
    class="card"
    :class="cardData.hasImageLogo ? '' : 'noImage'"
    @click="cardData.hasBackside ? (flipCard = !flipCard) : (flipCard = false)"
  >
    <div
      class="card__side card__side--front"
      :class="flipCard ? 'card__side--back card__side--back-1' : ''"
    >
      <div class="card__picture" v-if="cardData.hasImageLogo">
        <figure>
          <img
            class="icon"
            alt="Vue logo"
            src="../../assets/images/logo-branco.png"
          />
        </figure>
      </div>
      <h4 class="card__heading">
        <span class="card__heading-span card__heading-span--1">{{
          cardData.title
        }}</span>
      </h4>
      <div class="card__details">
        <ul>
          <li v-for="item of cardData.frontsideItems" :key="item">
            {{ item.value }}
          </li>
          <li v-show="cardData.hasPlusSign">+</li>
        </ul>
      </div>
    </div>
    <div
      class="card__side"
      :class="
        flipCard
          ? 'card__side--front card__side--back-1'
          : 'card__side--back card__side--back-1'
      "
    >
      <div class="card__cta">
        <div class="card__picture--back">
          <figure>
            <img
              class="icon"
              alt="Vue logo"
              src="../../assets/images/logo-branco.png"
            />
          </figure>
        </div>
        <div class="card__price-box">
          <ul>
            <li v-for="item of cardData.backsideItems" :key="item">
              {{ item.value }}
            </li>
          </ul>
        </div>
        <a href="#popup" class="btn btn--white btn--back"> &lt; voltar</a>
      </div>
    </div>
  </div>
</template>

<script>
import { ref } from 'vue'

export default {
  name: 'Card',
  props: ['card-data'],
  setup (props) {
    const flipCard = ref(false)
    return {
      flipCard
    }
  }
}
</script>

<style lang="scss" scoped>
@import "~@/styles/mixin.scss";
@import "~@/styles/variables.scss";
.noImage {
  .card__heading {
    font-size: 1.6rem;
    top: 5%;
  }
  .card__details {
    padding-top: 10rem;
    ul {
      width: 100%;
    }

    li {
      font-size: 1.2rem;
      text-align: left;
      list-style-type: disc;
    }
  }
}

.card {
  // FUNCTIONALITY
  perspective: 150rem;
  -moz-perspective: 150rem;
  position: relative;
  height: 100%;
  max-width: 25rem;

  &__side {
    height: 40rem;
    transition: all 0.8s ease;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    -webkit-backface-visibility: hidden;
    backface-visibility: hidden;
    border-radius: 3px;
    overflow: hidden;
    box-shadow: 0 1.5rem 4rem rgba($black, 0.15);

    &--front {
      background-color: $blue;
    }

    &--back {
      transform: rotateY(180deg);

      &-1 {
        background: $purple;
      }
    }
  }

  &:target &__side--front {
    transform: rotateY(-180deg);
  }

  &:target &__side--back {
    transform: rotateY(0);
  }

  // FRONT SIDE STYLING
  &__picture {
    padding-top: 2rem;
    background-color: $blue;
    height: 16rem;
    img {
      height: 6rem;
    }
  }

  &__heading {
    font-size: 2.8rem;
    font-weight: bold;
    text-transform: uppercase;
    text-align: center;
    color: $white;
    position: absolute;
    top: 12rem;
    right: 0rem;
    width: 100%;
  }

  &__details {
    padding: 3rem;

    ul {
      list-style: none;
      width: 80%;
      margin: 0 auto;

      li {
        text-align: center;
        font-size: 1.5rem;
        padding: 0.5rem;
        color: $white;
      }
    }
  }

  // Back SIDE STYLING
  &__cta {
    position: absolute;
    top: 50%;
    left: 43%;
    transform: translate(-50%, -50%);
    padding-left: 5rem;
  }

  &__picture--back {
    text-align: left;
    img {
      height: 4rem;
    }
  }

  &__price-box {
    min-width: 20rem !important;
    min-height: 27rem;
    text-align: left;
    color: $white;
    margin-top: 2rem;
  }

  &__price-only {
    font-size: 1.4rem;
    text-transform: uppercase;
  }

  &__price-value {
    font-size: 6rem;
    font-weight: 100;
  }

  .btn--back {
    color: $white;
    position: absolute;
    left: 20%;
    margin-top: 0.5rem;
  }
  //@include respond(tab-port) {
}
</style>
